export const LinearIndeterminateLoader = () => {
  return (
    <div className="h-1 w-full overflow-hidden rounded-lg bg-black-8">
      <div className="h-full w-full animate-indeterminate-progress-bar rounded-lg bg-dark-green-900" />
    </div>
  );
};
